<template>
  <page-wrapper background="/static/img/anniversary/page-key-words/bg.png">
    <img class="main-title ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-key-words/5.png" />
    <div class="tips-c"> 点此生成您下半年的科研关键词</div>
    <img class="brand-area ani" @click="handleButtonClick" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-key-words/button.png" />
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'

export default {
  components: { PageWrapper },
  methods: {
    handleButtonClick () {
      this.swiper.slideNext()
    }
  },
  props: [
    'swiper'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .main-title {
    position: absolute;
    top: 3.857vw;
  }

  .main-button {
    width: 73.86vw;
    height: 17.86vw;
    position: absolute;
    left: 50%;
    margin-left: -36.93vw;
    bottom: 36vw;
  }

  .brand-area {
    position: absolute;
    left: 7.182vw;
    top: 145vw;
    width: 82.46vw;
    height: 32.186vw;
    opacity: 1;
  }
  .tips-c {
    position: absolute;
    left: 10vw;
    top: 135.22vw;
    width: 75.012vw;
    height: 9.31vw;
    opacity: 1;

    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: 350;
    line-height: 35px;
    letter-spacing: -0.3px;

    color: #193543;

  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6232fa20